export function isValidPhone(phoneNumber) {
  var noExtraCharacters = /^[0-9\-\+\(\) ]+$/i.test(phoneNumber);
  var hasSixNumbers = (phoneNumber.match(/[0-9]/g) || []).length > 5;
  return noExtraCharacters && hasSixNumbers;
}
